import get from "lodash/get";

/**
 * Ng Redux Service - The class is a helper class to retrieve redux state from store.
 * The redux implementation and initation is done in discover-web, therefore this module
 * is able to access the redux store since it's imported in discovery-web.
 * @see [DiscoveryWeb-Redux]{@link https://github.com/meltwater/discovery-web/blob/master/flamingo/discovery-app/src/reducers/redux-store.module.ts}
 * @see [SSAModule]{@link https://github.com/meltwater/discovery-web/blob/e350d30a30321279e1b00ba402358f6751f96f86/flamingo/discovery-app/src/containers/explore/explore.module.ts#L31}
 */
export class ReduxService {

  private state: any;
  private treatments: any;

  /*@ngInject*/
  static $inject = ['$ngRedux']
  constructor($ngRedux: any) {
    $ngRedux.connect(this.mapStateToThis)(this)
  }

  /**
   * Get the value of the redux state based on the specified key property.
   * @param stateKey is the key property. Can be a single key or dotted nested key. e.g state.prop1.prop2
   */
  getValue(stateKey) {
      return get(this.state, stateKey);
  }

  isTreatmentEnabled(treatment: string) {
    return this.treatments && this.treatments[treatment] === 'on';
  }

  private mapStateToThis = (state: any) => ({
      state: state,
      treatments: state.user.treatments
  });
}